import { isValid, electronicFormat, printFormat, isValidBBAN, fromBBAN, toBBAN } from 'iban';
const formatIban = ({ iban, separator }) => printFormat(iban, separator);
const isValidIban = (iban) => isValid(iban);
const isValidBban = ({ bban, country }) => isValidBBAN(country, bban);
const electronicFormattedIban = (iban) => electronicFormat(iban);
const convertBbanToIban = ({ bban, country }) => fromBBAN(country, bban);
const convertIbanToBban = ({ iban, separator }) => toBBAN(iban, separator);
export { formatIban, isValidIban, electronicFormattedIban, isValidBban, convertBbanToIban, convertIbanToBban };
//# sourceMappingURL=iban.utils.js.map